export const getLocalLicenseQueryKey = ["getLocalLicense"];
export const getSecondaryMachineIdKey = ["getSecondaryMachineId"];
